/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_A3Inputs */

const en_guide_json_schema_faq_a3 = /** @type {(inputs: Guide_Json_Schema_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a widely adopted specification maintained as a set of IETF drafts, and most languages have mature validator libraries. Several drafts exist, so it helps to note which one your tools target.`)
};

const ko_guide_json_schema_faq_a3 = /** @type {(inputs: Guide_Json_Schema_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`널리 채택된 명세로 IETF 드래프트 형태로 관리되며, 대부분의 언어에 성숙한 검증 라이브러리가 있습니다. 여러 드래프트가 있으니 사용하는 도구가 어떤 버전을 대상으로 하는지 확인하면 좋습니다.`)
};

const ja_guide_json_schema_faq_a3 = /** @type {(inputs: Guide_Json_Schema_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広く採用されている仕様で、IETF のドラフト群として管理され、ほとんどの言語に成熟した検証ライブラリがあります。複数のドラフトが存在するので、使うツールがどのバージョンを対象にしているか確認するとよいでしょう。`)
};

/**
* | output |
* | --- |
* | "It is a widely adopted specification maintained as a set of IETF drafts, and most languages have mature validator libraries. Several drafts exist, so it help..." |
*
* @param {Guide_Json_Schema_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_a3 = /** @type {((inputs?: Guide_Json_Schema_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_a3(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_a3(inputs)
	return ja_guide_json_schema_faq_a3(inputs)
});